<div class="container-fluid">
	<div class="mb-2">
		<h1 class="mb-0">Database reset</h1>
		<div class="card-body">
			<div class="row g-3 align-items-end">
				<div class="col-md-2">
					<label class="form-label">Zip:</label>
					<input type="text" class="form-control" placeholder="Zip" maxlength="5" [(ngModel)]="filters.zip" (input)="onZipInput($event)" />
				</div>
				<div class="col-md-2">
					<label class="form-label">Radius in miles:</label>
					<input type="text" class="form-control" placeholder="Radius" [(ngModel)]="filters.radius" />
				</div>
				<div class="col-md-3">
					<label class="form-label">State:</label>
					<ng-select [items]="states" bindLabel="name" bindValue="code" placeholder="Select a state" [(ngModel)]="filters.state"> </ng-select>
				</div>
				<div class="col-md-3">
					<label class="form-label">City:</label>
					<input type="text" class="form-control" placeholder="City" [(ngModel)]="filters.city" />
				</div>
				<div class="col-md-2 d-flex gap-2">
					<button class="btn btn-primary w-100" (click)="search()">
						<span *ngIf="!isSearching">Search</span>
						<span *ngIf="isSearching">
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="searchedByZipOrRadius">
		<div class="col-12">
			<label for="" style="cursor: pointer" (click)="showZipCodes()">
				<span>Searchs API with in last hour: {{ searchs }}</span> <br />
				<span>Show zip codes </span>
				<i [ngClass]="['fa', showingZipCodes ? 'ri-arrow-up-s-fill' : 'ri-arrow-down-s-fill']"></i>
			</label>
			<div class="col-12" *ngIf="showingZipCodes">
				<p>{{ searched_zips.join(", ") }}</p>
			</div>
		</div>
	</div>
</div>

<div class="card appointments-card">
	<div class="card-header d-flex justify-content-between align-items-center">
		<h5 class="mb-0">Appointments</h5>

		<div class="d-flex align-items-center gap-2">
			<input #apnmntSearch type="text" class="form-control" style="width: 250px" placeholder="Search..." (keyup)="updateFilter($event)" />

			<app-new-column-selector [columns]="allColumns"> </app-new-column-selector>
		</div>
	</div>
	<div class="datatable-wrapper">
		<ngx-datatable #table class="material striped appointments-table" [rows]="rows" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [limit]="10" [rowHeight]="'auto'" [selected]="selected" [selectionType]="SelectionType.checkbox" (select)="onSelect($event)" (activate)="onActivate($event)" [scrollbarH]="true">
			<ngx-datatable-column *ngFor="let col of visibleColumns" [name]="col.name" [prop]="col.prop" [flexGrow]="0.5">
				<ng-template ngx-datatable-cell-template let-row="row" let-value="value">
					<!-- FECHA -->
					<span *ngIf="col.type === 'date'">
						{{ value | date: "mediumDate" }}
					</span>

					<span *ngIf="col.type === 'phone'">
						{{ formatPhone(value) }}
					</span>

					<span *ngIf="!col.type">
						{{ value }}
					</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column name="">
				<ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
					<div class="d-flex justify-content-end gap-2">
						<button class="btn btn-danger btn-sm btn-review" (click)="openDisposModal(row.primary_phone, rowIndex, disposModal)" [disabled]="loadingDispos[rowIndex]">
							<span *ngIf="loadingDispos[rowIndex]" class="spinner-border spinner-border-sm"> </span>
							<span *ngIf="!loadingDispos[rowIndex]">DISPOS</span>
						</button>
						<button (click)="openCampaignModal(campaignModal, row.primary_phone)" class="btn btn-sm btn-primary px-3">Open</button>
					</div>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
	</div>
</div>

<!--modal template for DISPOS -->
<ng-template #dispos_modal let-modal>
	<div class="modal-header border-0 pb-0">
		<h4 class="modal-title fw-bold">Dispos</h4>

		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>

	<div class="modal-body pt-2 dispos-modal-body">
		<div class="row">
			<div class="col-12" *ngFor="let dispo of allDispos; let i = index">
				<div class="card dispo-card">
					<div class="card-body p-2">
						<div class="d-flex justify-content-between align-items-start mb-2">
							<div>
								<span class="badge bg-danger me-1">
									{{ dispo.dispo }}
								</span>

								<p>{{ dispo.campaign_name }}</p>
								- <em>{{ dispo.user_login }}</em>
							</div>

							<small class="text-muted">
								{{ dispo.date | date: "medium" }}
							</small>
						</div>

						<p class="text-secondary mb-2">
							{{ dispo.notes }}
						</p>

						<div class="d-flex gap-3">
							<span class="text-muted" style="cursor: pointer">
								0
								<i ngbTooltip="Coming Soon..." class="fa fa-thumbs-up"></i>
							</span>

							<span class="text-muted" style="cursor: pointer">
								0
								<i ngbTooltip="Coming Soon..." class="fa fa-thumbs-down"></i>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="modal-footer border-0 justify-content-end">
		<button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">Close</button>
	</div>
</ng-template>

<!-- modal template for Select Campaign -->
<ng-template #campaignModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Select Campaign</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body py-4">
		<label class="form-label fw-semibold">Campaign</label>

		<div class="d-flex align-items-center gap-2 mb-2" *ngIf="isLoadingCampaigns">
			<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
			<small class="text-muted">Refreshing campaigns...</small>
		</div>

		<input type="text" class="form-control" [placeholder]="isLoadingCampaigns ? 'Loading campaigns...' : 'Click to see all campaigns, or type to search...'" [(ngModel)]="campaignSearchTerm" name="campaignSearch" #campaignTypeahead="ngbTypeahead" [ngbTypeahead]="searchCampaigns" [resultFormatter]="campaignFormatter" [inputFormatter]="campaignFormatter" [disabled]="isLoadingCampaigns" (selectItem)="onCampaignSelected($event)" (focus)="onCampaignInputFocus($event.target.value)" (click)="onCampaignInputClick($event.target.value)" />
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
		<button type="button" class="btn btn-primary" [disabled]="isLoadingCampaigns || isValidatingCampaign" (click)="openProspect()">
			<span *ngIf="!isValidatingCampaign">Open</span>
			<span *ngIf="isValidatingCampaign">
				<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
				Checking...
			</span>
		</button>
	</div>
</ng-template>
